import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        width: '100%',
        height: '100vh',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FEFEFE',
        opacity: 0.4,
        position: 'fixed',
        zIndex: 9999,
        left: 0,
        right: 0,
        bottom: 0,
        top: 0
    },
    container: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    mainContainer: {
        flexGrow: 1,
        backgroundColor: '#FEFEFE',
        minHeight: '100vh',
        boxShadow: '0 0 3px 1px rgba(0,0,0,.1)',
    },
}))

export default useStyles